import { Injectable } from '@angular/core';

import { ContextService } from '../shared-context/context.service';

@Injectable({
    providedIn: 'root'
})
export class DateService {

    public static DAY = 24 * 60 * 60 * 1000;

    private readonly mockDate: Date;
    private readonly startDate: Date; // When the page loaded. Used to return the correct mock date relative to the page load

    constructor(
        private readonly contextService: ContextService
    ) {
        this.startDate = new Date();
        const dateOverride = this.contextService.sharedContext.dateOverride;
        if (dateOverride) {
            this.mockDate = new Date(dateOverride);
        }
    }

    public getCurrentDate(): Date {
        if (this.mockDate) {
            const timeSincePageLoad = (new Date()).getTime() - this.startDate.getTime();
            return new Date(this.mockDate.getTime() + timeSincePageLoad);
        }

        return new Date();
    }

    public getCurrentDateMinuteGranularity(): Date {
        const currentDate = this.getCurrentDate();
        currentDate.setSeconds(0, 0);

        return currentDate;
    }

    public getLocalMidnight(): Date {
        const midnight = this.getCurrentDate();
        midnight.setHours(0, 0, 0, 0);
        return midnight;
    }

    public timespanInSeconds(dateFrom: Date): number {
        const dateTo = this.getCurrentDate();
        return (dateTo.getTime() - dateFrom.getTime()) / 1000;
    }

    public getStartOfYear(): Date {
        const now = this.getCurrentDate();
        return new Date(now.getFullYear(), 0, 0, 0, 0, 0, 0);
    }

    public addDays(day: Date, days: number): Date {
        return new Date(day.getFullYear(), day.getMonth(), day.getDate() + days, day.getHours(), day.getMinutes(), day.getSeconds(), day.getMilliseconds());
    }

    public addHours(day: Date, hours: number): Date {
        return new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours() + hours, day.getMinutes(), day.getSeconds(), day.getMilliseconds());
    }

    public addSeconds(day: Date, seconds: number): Date {
        return new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours(), day.getMinutes(), day.getSeconds() + seconds, day.getMilliseconds());
    }
}
